const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: '',
  },
  querySelector() {
    return null
  },
  querySelectorAll() {
    return []
  },
  getElementById() {
    return null
  },
  createEvent() {
    return {
      initEvent() {},
    }
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return []
      },
    }
  },
  createElementNS() {
    return {}
  },
  importNode() {
    return null
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: '',
  },
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: '',
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: '',
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {},
  },
  CustomEvent: function CustomEvent() {
    return this
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return ''
      },
    }
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {}
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback()
      return null
    }
    return setTimeout(callback, 0)
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return
    }
    clearTimeout(id)
  },
}

export const _window = typeof window !== 'undefined' ? window : ssrWindow
export const _document =
  typeof document !== 'undefined' ? document : ssrDocument

export const isMobile = () =>
  _window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )

export const isIOS = !!_window.navigator.userAgent.match(
  /\(i[^;]+;( U;)? CPU.+Mac OS X/
)

export const arrayToString = (str, joinSymbol = ';') => {
  if (!str) return ''
  if (str && typeof str === 'object' && Array.isArray(str)) {
    return str.join(joinSymbol)
  }
  return str
}

const jumpToWebShare = (url) => _window.open(url)

export const shareToFacebook = ({ shareTitle = '', shareUrl = '' }) => {
  jumpToWebShare(
    `https://www.facebook.com/sharer/sharer.php?shareTitle=${encodeURIComponent(
      shareTitle
    )}&u=${encodeURIComponent(shareUrl)}`
  )
}

export const shareToTwitter = ({ shareTitle = '', shareUrl = '' }) => {
  jumpToWebShare(
    `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      shareTitle
    )}&url=${encodeURIComponent(shareUrl)}`
  )
}

export const shareToWhatsApp = ({ shareTitle = '', shareUrl = '' }) => {
  const shareToWeb = () => {
    jumpToWebShare(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        shareTitle
      )}${encodeURIComponent('\n\n' + shareUrl)}`
    )
  }
  if (isMobile()) {
    _window.location.href = `whatsapp://send?text=${encodeURIComponent(
      shareTitle
    )}${encodeURIComponent('\n\n' + shareUrl)}`
    deeplinkFailedCallback(() => shareToWeb())
  } else {
    shareToWeb()
  }
}

export const shareToEmail = (options = {}) => {
  const { shareTitle = '', shareUrl = '', addressee, cc, bcc } = options
  let url = 'mailto:'
  url = addressee ? `${url}${arrayToString(addressee)}` : url
  url = cc ? `${url}?cc=${arrayToString(cc)}` : url
  const bccStr = `bcc=${arrayToString(bcc)}`
  url = bcc
    ? url.indexOf('?') > -1
      ? `${url}&${bccStr}`
      : `${url}?${bccStr}`
    : url
  const subject_body_str = `subject=${encodeURIComponent(
    shareTitle
  )}&body=${encodeURIComponent(shareTitle + ':' + '\n')}${encodeURIComponent(
    shareUrl
  )}`
  url =
    url.indexOf('?') > -1
      ? `${url}&${subject_body_str}`
      : `${url}?${subject_body_str}`
  jumpToWebShare(url)
}

export const shareToMessenger = (options = {}) => {
  let { shareTitle = '', shareUrl = '', link = '', app_id = '' } = options
  if (!link) {
    link = shareUrl
  }
  if (link.indexOf('localhost') > -1) {
    throw new Error('link不能为localhost，必须为一个可外网访问的链接')
  }
  const shareToWeb = () => {
    jumpToWebShare(
      `http://www.facebook.com/dialog/send?display=popup&app_id=${app_id}&href=${encodeURIComponent(
        shareUrl
      )}&link=${encodeURIComponent(link)}&redirect_uri=${encodeURIComponent(
        shareUrl
      )}&quote=${encodeURIComponent(shareTitle)}`
    )
  }
  if (isMobile()) {
    _window.location.href = `fb-messenger://share?app_id=${app_id}&link=${shareUrl}`
    deeplinkFailedCallback(() => shareToWeb())
  } else {
    shareToWeb()
  }
}

export const shareToSms = (options = {}) => {
  const {
    phoneNumber,
    shareTitle = '',
    shareSummary = '',
    shareUrl = '',
  } = options
  _window.location.href = `sms:${arrayToString(phoneNumber, ',')}${
    isIOS ? '&' : '?'
  }body=${
    shareTitle ? encodeURIComponent(shareTitle) + ': \n' : ''
  }${encodeURIComponent(shareSummary)} ${encodeURIComponent(shareUrl)}`
}

export const shareToLinkedin = (options = {}) => {
  const { shareUrl = '', shareTitle = '', shareSummary = '' } = options
  jumpToWebShare(
    `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      shareUrl
    )}&shareTitle=${encodeURIComponent(
      shareTitle
    )}&summary=${encodeURIComponent(shareSummary)}&source=LinkedIn`
  )
}

export const shareToTelegram = (options = {}) => {
  const { shareTitle = '', shareUrl = '' } = options
  const shareToWeb = () => {
    jumpToWebShare(
      `https://telegram.me/share/msg?url=${encodeURIComponent(
        shareUrl
      )}&text=${encodeURIComponent(shareTitle)}`
    )
  }
  if (isMobile()) {
    _window.location.href = `tg://msg?url=${encodeURIComponent(
      shareUrl
    )}'&text=${encodeURIComponent(shareTitle)}`
    deeplinkFailedCallback(() => shareToWeb())
  } else {
    shareToWeb()
  }
}

export const shareToPinterest = (options = {}) => {
  const { shareTitle = '', shareUrl = '' } = options
  jumpToWebShare(
    `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
      shareUrl
    )}&description=${encodeURIComponent(shareTitle)}&media=image`
  )
}

export const shareToVK = (options = {}) => {
  const { shareTitle = '', shareUrl = '', shareImageUrl = '' } = options
  jumpToWebShare(
    `https://vk.com/share.php?url=${encodeURIComponent(
      shareUrl
    )}&title=${encodeURIComponent(shareTitle)}&image=${encodeURIComponent(
      shareImageUrl
    )}&noparse=true`
  )
}

function deeplinkFailedCallback(shareToWeb) {
  const startDeeplink = +new Date()
  let deeplinkIsSuccess = false
  // 如果3s内没有dp，则跳转到web端
  const timeid = setInterval(() => {
    if (deeplinkIsSuccess) {
      clearInterval(timeid)
      return
    }
    const hidden =
      _document.hidden ||
      _document.mozHidden ||
      _document.msHidden ||
      _document.webkitHidden
    if (hidden) {
      clearInterval(timeid)
      return
    }
    const currentTs = +new Date()
    if (currentTs - startDeeplink > 3000 && !deeplinkIsSuccess) {
      clearInterval(timeid)
      shareToWeb && typeof shareToWeb === 'function' && shareToWeb()
    }
  }, 70)

  const visibilitychangeHandler = () => {
    // deeplink success
    if (_document.visibilityState === 'visible') {
      clearInterval(timeid)
      deeplinkIsSuccess = true
      _document.removeEventListener('visibilitychange', visibilitychangeHandler)
    }
  }
  // 监听browser是否隐藏
  _document.addEventListener('visibilitychange', visibilitychangeHandler, false)
}
